module.exports = __webpack_public_path__ + "01f20a35ce7c5630c1e43d3735dae864.jpg";